<div class="tpod-shell h-full bg-white text-slate-900">
  <div *ngIf="loading" class="flex h-full items-center justify-center gap-2 text-xs font-bold text-slate-500">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span>Loading trip details</span>
  </div>

  <div *ngIf="!loading" class="flex h-full min-h-0 flex-col">
    <div class="flex min-h-[46px] items-center justify-between gap-3 border-b border-slate-200 bg-slate-50 px-3 py-2">
      <div class="min-w-0">
        <div class="flex min-w-0 flex-wrap items-center gap-2">
          <span class="truncate text-sm font-black text-slate-950">{{ trip.asn_number || 'No ASN' }}</span>
          <span class="rounded-full border border-sky-200 bg-sky-50 px-2 py-0.5 text-[11px] font-black text-sky-700">Trip {{ trip.trip_number || '-' }}</span>
          <span *ngIf="customerName" class="truncate text-xs font-bold text-slate-600">{{ customerName }}</span>
        </div>
        <div class="mt-0.5 flex flex-wrap items-center gap-3 text-[11px] font-semibold text-slate-500">
          <span>{{ formatDateTime(trip.date) }}</span>
          <span>{{ shipments.length }} shipments</span>
          <span>{{ barcodes.length }} barcodes</span>
          <span>{{ pallets.length }} pallets</span>
        </div>
      </div>

      <div class="flex shrink-0 flex-wrap justify-end gap-1.5">
        <button type="button" class="tpod-action" (click)="openLabels()" title="Open package labels"><i class="fa-solid fa-tags"></i><span>Labels</span></button>
        <button type="button" class="tpod-action" (click)="addPackages()" title="Add packages"><i class="fa-solid fa-file-arrow-up"></i><span>Add</span></button>
        <button type="button" class="tpod-action" (click)="viewFullTrip()" title="View full trip"><i class="fa-solid fa-up-right-from-square"></i><span>Full</span></button>
        <button type="button" class="tpod-action" (click)="printTrip()" title="Print trip"><i class="fa-solid fa-print"></i><span>Print</span></button>
      </div>
    </div>

    <div *ngIf="errorMessage" class="mx-3 mt-2 rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-bold text-rose-700">
      <i class="fa-solid fa-triangle-exclamation mr-1"></i>{{ errorMessage }}
    </div>

    <div class="grid grid-cols-4 border-b border-slate-200 bg-white">
      <button
        *ngFor="let tab of tabs"
        type="button"
        class="tpod-tab"
        [class.is-active]="activeTab === tab.key"
        (click)="selectTab(tab.key)">
        <i class="fa-solid" [ngClass]="tab.icon"></i>
        <span>{{ tab.label }}</span>
        <em *ngIf="rowCounts[tab.key] !== null">{{ rowCounts[tab.key] }}</em>
      </button>
    </div>

    <div class="min-h-0 flex-1 overflow-hidden p-2" [ngSwitch]="activeTab">
      <div *ngSwitchCase="'details'" class="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
        <div *ngFor="let stat of detailStats" class="tpod-stat" [class.is-muted]="stat.tone === 'muted'">
          <span>{{ stat.label }}</span>
          <strong>{{ stat.value }}</strong>
        </div>
      </div>

      <ag-grid-angular
        *ngSwitchCase="'shipments'"
        class="ag-theme-ulaap-detail tpod-grid"
        [columnDefs]="shipmentColumnDefs"
        [rowData]="shipments"
        [defaultColDef]="defaultColDef">
      </ag-grid-angular>

      <ag-grid-angular
        *ngSwitchCase="'barcodes'"
        class="ag-theme-ulaap-detail tpod-grid"
        [columnDefs]="barcodeColumnDefs"
        [rowData]="barcodes"
        [defaultColDef]="defaultColDef"
        (cellEditingStopped)="onBarcodeEditingStopped($event)">
      </ag-grid-angular>

      <ag-grid-angular
        *ngSwitchCase="'pallets'"
        class="ag-theme-ulaap-detail tpod-grid"
        [columnDefs]="palletsColumnDefs"
        [rowData]="pallets"
        [defaultColDef]="defaultColDef">
      </ag-grid-angular>
    </div>
  </div>
</div>
